var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-3",staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.data))])
}
var staticRenderFns = []

export { render, staticRenderFns }